import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { MockProduct } from '../helpers/mockProduct';
import { StepNav } from './StepNav';

type ProductInfoStepProps = {
    product: MockProduct;
    onBack: () => void;
    onNext: () => void;
};

export const ProductInfoStep: FC<ProductInfoStepProps> = ({ product, onBack, onNext }) => {
    const { t } = useTranslation();

    const rows: { label: string; value: string }[] = [
        { label: t('mobileProductCapture.product.barcode'), value: product.barcode },
        { label: t('mobileProductCapture.product.name'), value: product.name },
        { label: t('mobileProductCapture.product.sku'), value: product.sku },
        { label: t('mobileProductCapture.product.color'), value: product.color },
        { label: t('mobileProductCapture.product.size'), value: product.size },
        { label: t('mobileProductCapture.product.status'), value: product.status },
    ];

    return (
        <div className="mpc-step mpc-step--product">
            <header className="mpc-step__header">
                <h2>{t('mobileProductCapture.product.title')}</h2>
                <p>{t('mobileProductCapture.product.subtitle')}</p>
            </header>

            <article className="mpc-product-card mpc-product-card--fill">
                <div className="mpc-product-card__badge">{t('mobileProductCapture.demoBadge')}</div>
                <ul className="mpc-product-card__rows">
                    {rows.map((row) => (
                        <li key={row.label}>
                            <span>{row.label}</span>
                            <strong>{row.value}</strong>
                        </li>
                    ))}
                </ul>
            </article>

            <StepNav
                onBack={onBack}
                onNext={onNext}
                backLabel={t('mobileProductCapture.nav.back')}
                nextLabel={t('mobileProductCapture.product.continue')}
            />
        </div>
    );
};
